export default __webpack_public_path__ + "static/media/street_img.9546f5ec.png";